/** @file applyTheme: sets `data-theme` on the document so tokens.css restyles the editor. */
import type { ThemeName } from './editorSettings';

/** `dark` removes the attribute (the default tokens); `darker` and `light` set it. */
export function applyTheme(theme: ThemeName, doc: Document = document): void {
  if (theme === 'dark') delete doc.documentElement.dataset['theme'];
  else doc.documentElement.dataset['theme'] = theme;
}
